/* eslint-disable react/prop-types */
import {TextField} from '@mui/material';

const TextInput = props => {
  console.log({TextInputProps: props});
  const {error, helperText, ...rest} = props;
  const hasError = props.error === true;
  console.log({hasError, helperText});

  return (
    <TextField
      error={hasError}
      helperText={error && helperText ? helperText : ''}
      type="text"
      size="small"
      fullWidth
      variant="outlined"
      {...rest}
      sx={{
        '& .MuiFormHelperText-root': {
          fontSize: 11,
          margin: 0
        },
        '& .MuiInputBase-root': {
          height: 38,
          overflow: 'hidden'
        },
        '& .Mui-disabled': {
          background: 'rgba(0,0,0,0.05)'
        },
        '& .MuiFormControl-root': {
          height: 38,
          overflow: 'hidden'
        },
        '& .MuiInputBase-input': {
          fontSize: 12
        },
        '& .MuiInputBase-input::placeholder': {
          fontSize: 12
        }
      }}
    />
  );
};

export default TextInput;
